import React from "react";
import { Card, Table } from "react-bootstrap";
import "./floorResultDisplay.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import moment from 'moment';
import isEqual from "react-fast-compare";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";

export default class FloorResultDisplay extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rooms: this.props.roomDetails
        }
    }
    componentDidUpdate(prevProps) {
        if (!isEqual(prevProps.datetime, this.props.datetime)) {
            this.setState({
                rooms: this.props.roomDetails,
            });
        }
    }

    render() {
        var settings = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 5,
            slidesToScroll: 5,
            initialSlide: 0,
            responsive: [
                {
                    breakpoint: 1530,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        dots: true,
                        infinite: false,                        
                    }
                },
                {
                    breakpoint: 1160,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: true,
                        infinite: false,
                    }
                },
                {
                    breakpoint: 730,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        infinite: false,
                    }
                }
            ]
        };
        return (
            <div className="carousel result-sample-cord ">
                <Row className="d-flex justify-content-between bd-highlight mb-2">
                    <Col className="room-name">  {this.props.roomName ? this.props.roomName : null}</Col>
                    <Col style={{textAlign: 'end', whiteSpace: 'noWrap'}}><span className="text-bold" style={{color: '#EE7D11'}}>CT</span><span className="text-description">- Complex Type  |  </span><span className="text-bold" style={{color: '#003883'}}>ST</span><span className="text-description">- Sequence Type  |  </span><span className="text-bold" style={{color: '#6F33E7'}}>NT</span><span className="text-description">- Novel Type  |  </span><span className="text-bold" style={{color: '#F600CD'}}>SNP</span><span className="text-description">- Single nucleotide polymorphisms</span></Col>
                </Row>
                {this.state.rooms.length > 0 ?
                    <Slider {...settings}>
                        {this.state.rooms.map((room) =>{
                            return(
                                room.samples.map((sample, index) => {
                                    return (
                                        <div key={index}>
                                            <Card className="card-complete">
                                                <Card.Body className="d-flex p-2 candidate-card">
                                                    <Table borderless>
                                                        <tbody className="h-100">
                                                            {sample.barcode ?
                                                                <tr>
                                                                    <td className="bodyCopy">{sample.barcode}</td>
                                                                    <td className="bodyCopy text-align-end" >{moment(new Date(sample.date_time)).format("MMM D, YYYY HH:mm")}</td>
                                                                </tr>
                                                                : null
                                                            }
                                                            {sample.location ?
                                                                <tr>
                                                                    <td className="bodyCopy">{sample.location + (sample.unit ? `_${sample.unit.unit_id}` : '')}</td>
                                                                </tr>
                                                                : null
                                                            }
                                                            {sample.type_of_analysis ?
                                                                <tr>
                                                                    <td className="bodyCopy">{sample.type_of_analysis}</td>
                                                                </tr>
                                                                : null
                                                            }
                                                            {sample.type_of_samples ?
                                                                <tr>
                                                                    <td className="bodyCopy">{sample.type_of_samples}</td>
                                                                </tr>
                                                                : null
                                                            }
                                                            {sample.result.other_analysis && sample.result.other_analysis === 'Positive' ?
                                                                <tr>
                                                                    <td className="bodyCopy text-bold" >Result  :</td>
                                                                    <td className="bodyCopy text-bold" style={{ color: '#f9766e' }}>{sample.result.other_analysis}</td>
                                                                </tr>
                                                                :
                                                                sample.result.other_analysis && sample.result.other_analysis === 'Negative' ?
                                                                    <tr>
                                                                        <td className="bodyCopy text-bold" >Result  :</td>
                                                                        <td className="bodyCopy text-bold" style={{ color: '#00bfc4' }}>{sample.result.other_analysis}</td>
                                                                    </tr>
                                                                    : null
                                                            }
                                                            {sample.result.complex_type || sample.result.sequence_type ?
                                                                <tr>
                                                                    <td className="bodyCopy text-bold">{sample.result.complex_type && sample.result.sequence_type ? `CT${sample.result.complex_type} | ST${sample.result.sequence_type}` : sample.result.complex_type ? `CT${sample.result.complex_type}` : sample.result.sequence_type ? `ST${sample.result.sequence_type}` : null}</td>
                                                                </tr>
                                                                : null
                                                            }
                                                            {sample.result.novel_type ?
                                                                <tr>
                                                                    <td className="bodyCopy text-bold">NT{sample.result.novel_type}</td>
                                                                </tr>
                                                                : null
                                                            }
                                                            {sample.reference_genome ?
                                                                <tr>
                                                                    <td className="bodyCopy text-bold" style={{ fontWeight: "normal!important" }}>ref no.{sample.reference_genome}</td>
                                                                </tr>
                                                                : null
                                                            }
                                                            {sample.type_of_analysis==="Microbiome" && sample.result.analysis_result_data?
                                                                <>
                                                                    <tr>
                                                                        <td className="bodyCopy text-bold"><b>Results</b></td>
                                                                    </tr>
                                                                    <td className="bodyCopy text-bold left"> 
                                                                        {Object.keys(sample.result.analysis_result_data.result).map((species, index) => {
                                                                            if(index%2==0 && index<=2)
                                                                                    return <>
                                                                                        <p class="species-percentage">{species}: {sample.result.analysis_result_data.result[species]}%</p>
                                                                                    </>;
                                                                        })
                                                                        }
                                                                    </td>
                                                                    <td className="bodyCopy text-bold">
                                                                        {Object.keys(sample.result.analysis_result_data.result).map((species, index) => {
                                                                            if(index%2!=0 && index<4)
                                                                                    return <>
                                                                                        <p class="species-percentage">{species}: {sample.result.analysis_result_data.result[species]}%</p>
                                                                                    </>;
                                                                        })
                                                                        }
                                                                    </td>
                                                                </>
                                                                : null
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </Card.Body>
                                            </Card>
                                        </div>
                                    )
                                })
                            )
                        })}
                    </Slider>
                    :
                    <div className="no-msg-text">No results available for this room.</div>}
            </div>
        );
    }
}
